import React, { ReactElement, ReactNode } from 'react';
import { Field } from 'react-final-form';
import { ResultAwareTask } from '~common/helper/mobx-tasks';
import { SelectTask } from '~web/view/components/ui/form/select-task.component';
import { SelectFieldOption } from '~common/components/select.component';

interface Props<T> {
  name: string;
  label: string;
  task: ResultAwareTask<T>;
  mapper: (result: T) => SelectFieldOption[];
  taskArgs?: any[];
  disabled?: boolean;
}

export const SelectFieldTask = <T extends object>(props: Props<T>): ReactElement => {
  const { name, label, task, taskArgs, mapper, disabled, ...rest } = props;

  return (
    <Field
      label={label}
      name={name}
      render={(renderProps): ReactNode => (
        <SelectTask
          task={task}
          mapper={mapper}
          taskArgs={taskArgs}
          disabled={disabled}
          {...renderProps}
        />
      )}
      {...rest}
    />
  );
};



// WEBPACK FOOTER //
// ./view/components/ui/form/fields/field-select-task.component.tsx